import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { setNeoAuthenticated } from "../../redux/actions/UserActions";
import { appConfig } from "App";

const NeoSessionCheck = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { sessionid } = useParams();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const validateSession = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionId = sessionid || urlParams.get('sessionid') || localStorage.getItem('sessionid');
        const cuesheetid = urlParams.get('cuesheetid') || urlParams.get('csId') || localStorage.getItem('cuesheet_id');
        const workspaceid = urlParams.get('workspaceid') || urlParams.get('workspaceId') || urlParams.get('ws') || localStorage.getItem('workspaceid');
        
        // Store parameters in localStorage
        if (sessionId) {
          localStorage.setItem('sessionid', sessionId);
        }
        if (cuesheetid) {
          localStorage.setItem('cuesheet_id', cuesheetid);
        }
        if (workspaceid) {
          localStorage.setItem('workspaceid', workspaceid);
        }
        // Check session validity with API, passing sessionid
        const response = await axios.post('/neo-session-check', {
          params: {
            uid: sessionId,
          },
        });
        if (response.data === "LOGIN SUCCESSFUL" || response.status === 200) {
          // Session is valid - set authentication and redirect
          dispatch(setNeoAuthenticated(true));
          
          if (cuesheetid) {
            history.push(`/neocuesheet/${cuesheetid}`);
          } else {
            history.push('/neocuesheet');
          }
        } else {
          // Session invalid - redirect to login
          window.location.href = `${appConfig.CENTRAL_API}/neo-login`;
        }
      } catch (error) {
        console.error('Session check failed:', error);
        // Session invalid - redirect to login
        window.location.href = `${appConfig.CENTRAL_API}/neo-login`;
      } finally {
        setChecking(false);
      }
    };

    validateSession();
  }, [dispatch, history, sessionid]);

  if (checking) {
    return (
      <div className="loader" style={{ padding: '20px', textAlign: 'center' }}>
        <CircularProgress />
        <p>Checking your session...</p>
      </div>
    );
  }

  return null;
};

export default NeoSessionCheck;
